import { render, staticRenderFns } from "./ShipmentOptions.vue?vue&type=template&id=450ee613&scoped=true&"
import script from "./ShipmentOptions.vue?vue&type=script&lang=js&"
export * from "./ShipmentOptions.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentOptions.vue?vue&type=style&index=0&id=450ee613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ee613",
  null
  
)

export default component.exports